import React, { PropTypes } from 'react';
import { Meta } from 'common/components/meta';
import Attribute from 'marketing/common/attribute';

const getErrorCode = (path) => {
  const matches = path.match(/\d+/);

  if (matches) {
    return parseInt(matches[0], 10);
  }
  return null;
};

const ErrorStates = {
  403: {
    title: 'Not authorized',
    text: "You don't have permissions to access this page.",
  },
  404: {
    title: 'The page monster ate&nbsp;your&nbsp;page.',
    text: 'We couldn\'t find the page you were looking for.',
  },
  500: {
    title: 'You found our&nbsp;gremlins.',
    text: 'There was a problem with the site. Our team has&nbsp;been&nbsp;notified and we&nbsp;will investigate the problem. Sorry&nbsp;for&nbsp;the&nbsp;trouble.',
  }
};

const ErrorPage = ({ error, router }) => {
  const errorCode = getErrorCode(router.location.pathname);
  const errorInstance = (errorCode && ErrorStates[errorCode]) || ErrorStates['500'];

  return (
    <div className="error-page l-content">
      <Meta
        title="Error"
        meta={[{ name: 'robots', content: 'noindex,nofollow' }]}
      />
      <div id="content" className="row">
        <div className="small-16 medium-8 column error-content align-middle">
          <h1 dangerouslySetInnerHTML={{ __html: errorInstance.title }} />
          <p dangerouslySetInnerHTML={{ __html: errorInstance.text }} />
          { error && error.incidentId && <p className="incident-id">
            Incident Id: { error.incidentId }
          </p> }
        </div>
        <div className="small-16 medium-8 columns">
          <div className="error-image">
            <img
              src="https://assets.crowdspring.com/marketing/crowdspring_error_app-blaster_haim.jpg"
              alt="App Blaster by Haim"
            />
            {router.push && <Attribute to="haim" />}
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  error: PropTypes.shape({
    incidentId: PropTypes.string,
  }),
  router: PropTypes.object,
};

export default ErrorPage;
